import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EditAlliedComponent } from '../edit-allied/edit-allied.component';

@Component({
  selector: 'app-confirmdisable',
  templateUrl: './confirmdisable.component.html',
  styleUrls: ['./confirmdisable.component.scss']
})
export class ConfirmdisableComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { title: string, statusAllied: boolean },
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<EditAlliedComponent>,
  ) { }

  ngOnInit(): void {
  }

  public closeModal(): void {
    this.dialogRef.close();
  }

}
